import React, { useMemo } from "react";
import { inject, observer } from "mobx-react";
import { Option } from "../../../../common/forms/Interfaces";
import SelectFilter from "../selectFilter";
import { IFilterProps, IFilterWithStoreProps } from "../Interfaces";

const ClientFilter: React.FC<IFilterWithStoreProps> = inject("store")(
  observer(
    ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      store,
      multiple,
    }) => {
      const settingsStore = store?.settingsStore;
      const options = useMemo(
        (): Option[] =>
          settingsStore?.clients
            ? settingsStore?.clients.map(
                (client: Option): Option => ({
                  value: client.value,
                  title: client.title,
                })
              )
            : [],
        [settingsStore]
      );

      return (
        <SelectFilter
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          options={options}
          selectedKeys={selectedKeys}
          multiple={multiple}
        />
      );
    }
  )
);

const Wrapper: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
  multiple,
}) => (
  <ClientFilter
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    selectedKeys={selectedKeys}
    multiple={multiple}
  />
);

export default Wrapper;
